import Cookies from "js-cookie";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ProtectedRoute = ({ Component }) => {
  const nav = useNavigate();

  useEffect(() => {
    const token = Cookies.get("authToken");
    const pendingToken = localStorage.getItem("pendingAuthToken");

    if (!token && !pendingToken) {
      nav("/");
      return;
    }

    if (!token && pendingToken) {
      nav("/");
      return;
    }

    if (token && window.location.pathname === "/") {
      nav("/authPage/jobdetails/openposition");
      return;
    }
  }, []);

  return (
    <div>
      <Component />
    </div>
  );
};

export default ProtectedRoute;
